var _ellipse, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnAboutInsuranceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.1862,
    cy: 9.89485,
    rx: 9.60091,
    ry: 9.60091,
    fill: "url(#paint0_linear_8_294)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41767 29.2833C2.61055 26.428 1.56443 23.0432 1.56443 19.4142C1.56443 9.20829 9.83793 0.934795 20.0438 0.934795C30.2497 0.934795 38.5232 9.20829 38.5232 19.4142C38.5232 29.62 30.2497 37.8935 20.0438 37.8935C18.4914 37.8935 16.9837 37.7021 15.5431 37.3416C13.7824 38.7105 8.84095 41.1558 3.16024 39.9863C4.58738 38.8376 7.50431 35.9137 7.75493 33.4075",
    stroke: "black",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_294",
    x1: 30.1862,
    y1: 0.293945,
    x2: 30.1862,
    y2: 19.4958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnAboutInsuranceIcon);
export default __webpack_public_path__ + "static/media/learnAboutInsuranceIcon.2bab28c422b949316d041bc6e4d16936.svg";
export { ForwardRef as ReactComponent };